export var ENTER_CHATROOM = 'ENTER_CHATROOM';
export var LEAVE_CHATROOM = 'LEAVE_CHATROOM';

export var ADDUSER = 'ADDUSER';
export var ADDUSER_SUCCESS = 'ADDUSER_SUCCESS';
export var ADDUSER_ERROR = 'ADDUSER_ERROR';

export var RETRIEVE_USER_SUCCESS = 'RETRIEVE_USER_SUCCESS';
export var RETRIEVE_USER_ERROR = 'RETRIEVE_USER_ERROR';

export var GET_CHATROOM_METADATA = 'GET_CHATROOM_METADATA';

export var SEND_MESSAGE = 'SEND_MESSAGE';
export var SEND_MESSAGE_SUCCESS = 'SEND_MESSAGE_SUCCESS';
export var SEND_MESSAGE_ERROR = 'SEND_MESSAGE_ERROR';
export var SELECT_MESSAGE = 'SELECT_MESSAGE';
export var UNSELECT_MESSAGE = 'UNSELECT_MESSAGE';
export var REPORT_MESSAGE_SUCCESS = 'REPORT_MESSAGE_SUCCESS';
export var REPORT_MESSAGE_ERROR = 'REPORT_MESSAGE_ERROR';
export var HIDE_VALIDATION_POPUP = 'HIDE_VALIDATION_POPUP';

export var SEND_PREVIEW = 'SEND_PREVIEW';
export var CANCEL_PREVIEW = 'CANCEL_PREVIEW';
export var START_UPLOAD = 'START_UPLOAD';

export var RETRIEVE_MESSAGE = 'RETRIEVE_MESSAGE';
export var UPDATE_MESSAGE = 'UPDATE_MESSAGE';
export var CLEAN_MESSAGES = 'CLEAN_MESSAGES';

export var SHOW_NOT_ENABLED_POPUP = 'SHOW_NOT_ENABLED_POPUP';
export var HIDE_NOT_ENABLED_POPUP = 'HIDE_NOT_ENABLED_POPUP';

export var ERROR = 'ERROR';


//////////////////
// WEBPACK FOOTER
// ./node_modules/nm-react-chat/es/components/Chatroom/chatroomActionTypes.js
// module id = 60
// module chunks = 0